export default __webpack_public_path__ + "static/media/2star-a.64c66a32.png";